import React from 'react';
import { Box, Typography } from '@material-ui/core';

interface Props {
  minValue?: number;
  maxValue?: number;
  minLabel?: string;
  maxLabel?: string;
}

export const LinearScaleFieldPreview = React.memo(({ minValue = 1, maxValue = 5, minLabel, maxLabel }: Props) => {
  const values = [];
  for (let i = minValue; i <= maxValue; i++) {
    values.push(i);
  }

  return (
    <Box>
      {(minLabel || maxLabel) && (
        <Box display='flex' justifyContent='space-between' mb={0.5}>
          <Typography variant='caption' color='textSecondary'>
            {minLabel}
          </Typography>
          <Typography variant='caption' color='textSecondary'>
            {maxLabel}
          </Typography>
        </Box>
      )}
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        {values.map((val) => (
          <Box
            key={val}
            display='flex'
            alignItems='center'
            justifyContent='center'
            style={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              border: '1px solid #bdbdbd',
              backgroundColor: '#f5f5f5',
            }}
          >
            <Typography variant='caption' color='textSecondary'>
              {val}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
});
